import { useEffect, useState } from 'react'
import { APP_ROUTES } from "constants/AppRoutes";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form';
import { ListGroup } from 'react-bootstrap';
import { Button } from 'primereact/button';
//icons
import { BsArrowRight } from "react-icons/bs";
import { RiFileExcel2Line } from 'react-icons/ri';
//components
import InformationBox from 'components/common/Message/InformationBox/InformationBox';
import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import ReportViewer from 'components/common/Report/ReportViewer'
//redux
import { onExportReport } from 'redux/common/report/customizeReportSlice';
import { useAppSelector } from "../../redux/hooks";
import { createReportPreviewSession, setReportPreviewSession } from "../../redux/pages/Administration/Site/siteSlice";
import { useDispatch } from "react-redux";
import { FiExternalLink } from 'react-icons/fi';
import CommonFilter from 'pages/SalesActivityReport/CommonFilter';
import { getBranchOfficeListForSystemReport, getPanelTypeListForSystemReport, setSelectedBranchOfficeListForSystemReport, setSelectedPanelTypeForSystemReport, setSelectedSystemStatusForSystemReport } from 'redux/pages/Reports/SystemReportSlice';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { SYSTEM_REPORT_COLS } from './SystemReportTableData';

type FormData = {
	systemStatus: string
	sortBy: string
};

const SystemReports = () => {

	const {
		control,
		setValue,
	} = useForm<FormData>({
		defaultValues: {
			systemStatus: "",	
			sortBy: "",		
		},
	});

	const [reportName, setReportName] = useState<any>(null);
	const [displayInfoModal, setDisplayInfoModal] = useState(false);
    const [message, setMessage] = useState<string>("");
	const reportPreviewSession = useAppSelector((state) => state.site.reportPreviewSession);
	const branchOffices = useAppSelector((state) => state.systemReport.branchOfficeListForSystemReport);
	const panelTypes = useAppSelector((state) => state.systemReport.panelTypeForSystemReport);
	const selectedBranchOfficeList = useAppSelector((state) => state.systemReport.selectedBranchOfficeListForSystemReport);
	const selectedPanelTypeList = useAppSelector((state) => state.systemReport.selectedPanelTypeForSystemReport);
	const selectedSystemStatus = useAppSelector((state) => state.systemReport.selectedSystemStatusForSystemReport);
	

	//const siteList = useAppSelector((state) => state.common.sitelist); 			--------Purposefully commented
	//const [systemReportSiteList, setSystemReportSiteList] = useState<any>([]); 	--------Purposefully commented
	//const [selectedSite, setSelectedSite] = useState<string>(''); 				--------Purposefully commented
	const [filterIdentifier, setFilterIdentifier] = useState<string>("");
	const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
	const [selectedData, setSelectedData] = useState<any>([]);
	const [gridData, setGridData] = useState<any>([]);
	const [dataKey, setDataKey] = useState<string>("");
	const [field, setField] = useState<string>("");
	const [header, setHeader] = useState<string>("");
	const [title, setTitle] = useState<string>("");
	const [sortColumn, setSortColumn] = useState<any>("");
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const [disabled, setDisabled] = useState<boolean>(true);

	const systemStatus = [
		{ statusId: 1, statusName: 'Active' },
		{ statusId: 3, statusName: 'Closed' }
	];

	useEffect(() => {
		if(sortColumn.length){
			let type = "SECTION_REPORT";
					let reportParameters = getReportParametersForReportandExcelExport(type);
					dispatch(createReportPreviewSession(reportParameters))
		}
		}, [sortColumn]);

	// useEffect(() => {
	// 	dispatch(getSystemReportSiteList())
	// }, []);					--------------------------- Purposefully commented																			

	// useEffect(() => {
	// 	if (siteList && siteList.length) {
	// 		const otherSites = siteList.filter(site => site.siteName !== "All");
	// 		const sortedOtherSites = otherSites.sort((a, b) => a.siteName.localeCompare(b.siteName));
	// 		const sortedSiteList = [{siteName: "All",uniqueSiteId: ""}, ...sortedOtherSites];
	// 		setValue("site", "All");
	// 		setSystemReportSiteList(sortedSiteList);
	// 	}
	// }, [siteList]);				--------------------------- Purposefully commented

	  useEffect(() => {
		dispatch(setSelectedBranchOfficeListForSystemReport([]));
		dispatch(setSelectedPanelTypeForSystemReport([]));
		dispatch(setSelectedSystemStatusForSystemReport([]));
	  }, [])

	useEffect(() => {
		return (() => {
			dispatch(setReportPreviewSession(""));
		})
	}, []);

	useEffect(() => {
		if (filterIdentifier && filterIdentifier === "System Report Branch Offices") {
			dispatch(getBranchOfficeListForSystemReport());
		} else if (filterIdentifier && filterIdentifier === "System Report Panel Types") {
			let branchOfficeIds: any = [];
			selectedBranchOfficeList?.forEach(element => {
				branchOfficeIds.push(element?.branchOfficeId);
			});
			let combinedbranchOfficeIds: any = [];
			combinedbranchOfficeIds = branchOfficeIds.join(',');
			const body = {
				branchOfficeIds: combinedbranchOfficeIds,
			}
			dispatch(getPanelTypeListForSystemReport(body));		
		}
	}, [filterIdentifier])

	useEffect(() => {
		if (filterIdentifier === "System Report Branch Offices") {
			if (branchOffices)
				setGridData(branchOffices);
			else
				setGridData([]);
		}
		else if (filterIdentifier === "System Report Panel Types") {
			if (panelTypes)
				setGridData(panelTypes);
			else
				setGridData([]);
		}		
	}, [branchOffices, panelTypes])
	
	useEffect(() => {
		if (reportPreviewSession) {
			setReportName(reportPreviewSession.previewSessionId);
		}
	}, [reportPreviewSession])

	const onBranchOfficeFilterClick = () => {
		setTitle("Branch Offices");
		setHeader("Branch Office");
		setField("branchOfficeName");
		setDataKey("branchOfficeId");
		setFilterIdentifier("System Report Branch Offices");
		setSelectedData(selectedBranchOfficeList);
		setShowFilterModal(true);
	}

	const onPanelTypeFilterClick = () => {
		if (!selectedBranchOfficeList?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one Branch Office");
			return;
		}
		setTitle("Panel Types");
		setHeader("Panel Type");
		setField("panelTypeName");
		setDataKey("panelTypeId");
		setFilterIdentifier("System Report Panel Types");
		setSelectedData(selectedPanelTypeList);
		setShowFilterModal(true);	
	}

	const onSystemStatusFilterClick =()=>{
		if (!selectedPanelTypeList?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one Panel Type");
			return;
		}
		setTitle("System Status");
		setHeader("System Status");
		setField("statusName");
		setDataKey("statusId");
		setGridData(systemStatus);
		setFilterIdentifier("System Report System Status");
		setSelectedData(selectedSystemStatus);
		setShowFilterModal(true);
	}

	const onApply = () => {
		if (!selectedBranchOfficeList?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one Branch Office");
			return;
		}
		if (!selectedPanelTypeList?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one Panel Type ");
			return;
		}
		if (!selectedSystemStatus?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one System Status ");
			return;
		}
		setDisabled(false);
		let type = "SECTION_REPORT";
		let reportParameters = getReportParametersForReportandExcelExport(type);
		dispatch(createReportPreviewSession(reportParameters))
	};

	const exportAsExcel = () => {
		if (!selectedBranchOfficeList?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one Branch Office");
			return;
		}
		if (!selectedPanelTypeList?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one Panel Type ");
			return;
		}
		if (!selectedSystemStatus?.length) {
			setDisplayInfoModal(true);
			setMessage("Select atleast one System Status ");
			return;
		}
		let type = "EXCEL";
		let exportParameters = getReportParametersForReportandExcelExport(type);
		dispatch(onExportReport(exportParameters, "System Report"));
	};

	const getReportParametersForReportandExcelExport = (type: any) => {
		let branchOfficeIds: any = [];
		selectedBranchOfficeList?.forEach(element => {
			branchOfficeIds.push(element?.branchOfficeId);
		});
		let panelTypeIds: any = [];
		selectedPanelTypeList?.forEach(element => {
			panelTypeIds.push(element?.panelTypeId);
		});
		let systemStatusIds: any = [];
		selectedSystemStatus?.forEach(element => {
			systemStatusIds.push(element?.statusId);
		});
		const reportParameters = {
			reportParameters: {
				branchOfficeIds: branchOfficeIds.join(','),
				panelTypeIds: panelTypeIds.join(','),
				systemStatusIds: systemStatusIds.join(','),
				sortColumn: sortColumn
			},
			reportType: "System Report"
		};
		const exportParameters = {
			exportParameters: {
				branchOfficeIds: branchOfficeIds.join(','),
				panelTypeIds: panelTypeIds.join(','),
				systemStatusIds: systemStatusIds.join(','),
				sortColumn: sortColumn
			},
			exportType: "System Report"
		};
		if (type === "SECTION_REPORT")
			return reportParameters;
		else if (type === "EXCEL")
			return exportParameters;
	}

	return (
		<div className='salesactivity-reports'>
			<section className="d-flex align-items-center">
				<Breadcrumb
					title="Reports"
					classNames="report-header"
					handleGoBackClick={() => navigate(`/${APP_ROUTES.REPORT_VIEW}`)}
				/>
				<div className="breadcrumb-right-arrow ml-3 mr-3">
					<BsArrowRight className="icon" />
				</div>
				<div className="breadcrumb-sub-page-title">
					<span>Systems</span>
				</div>
			</section>

			<div className="report-sort-field pt-2 pb-2">
				<div className="report-export-main">

					<div className='btn-wrapper'>
						
						<Button className='box-btn' onClick={() => onBranchOfficeFilterClick()}>
							Branch Office&nbsp;<label style={{ color: 'red' }}>*</label>
							<FiExternalLink />
						</Button>
						<Button className='box-btn' onClick={() => onPanelTypeFilterClick()}>
							Panel Type&nbsp;<label style={{ color: 'red' }}>*</label><FiExternalLink />
						</Button>
						<Button className='box-btn' onClick={() => onSystemStatusFilterClick()}>
							System Status&nbsp;<label style={{ color: 'red' }}>*</label><FiExternalLink />
						</Button>
						<div className='apply-button'>
							<Button label="Apply" className="submit-btn ml-2" autoFocus onClick={() => onApply()} />
						</div>
					</div>
					{/* <div className="report-buttons">
                            <ListGroup horizontal>
                                <ListGroup.Item><Button label="Customize" className="report-btn" onClick={() => setShowCustomizeReport(true)} /></ListGroup.Item>
                            </ListGroup>
                        </div> */}
						<div className="btn-wrapper report-field col-12 md:col-2">
							<div className="field  mb-0">
								<span className="p-float-label">
									<Controller
										name="sortBy"
										control={control}
										render={({ field, fieldState }) => (
											<Dropdown
												inputId="dropdown"
												className={classNames("w-100 error-tooltip", {
													error: fieldState.invalid,
												})}
												{...field}
												value={sortColumn}
												onChange={(e) => {
													setSortColumn(e.value);
												
												}}
												options={SYSTEM_REPORT_COLS}
												optionLabel="header"
												optionValue="field"
												disabled={disabled}
											/>
										)}
									/>
									<label htmlFor="dropdown">Sort by</label>
								</span>
							</div>
						</div>
					<div className="report-buttons-main d-flex">
						<div className='export-report-buttons'>
							<ListGroup horizontal>
								<span className='expor-title'>Export to</span>
								<ListGroup.Item>
									<Button className="export-btn" onClick={() => exportAsExcel()}> <RiFileExcel2Line className="icon" /> Excel </Button>
								</ListGroup.Item>
							</ListGroup>
						</div>
					</div>
				</div>
			</div>
			{showFilterModal ? <CommonFilter
				showModal={showFilterModal}
				gridData={gridData}
				selectedData={selectedData}
				onHide={(checkedData) => {
					setFilterIdentifier("");
					setShowFilterModal(false);
					setSelectedData(checkedData)
				}}
				field={field}
				header={header}
				title={title}
				dataKey={dataKey}
				filterIdentifier={filterIdentifier}
			/> : null}
			<ReportViewer reportId={reportName} />
			<InformationBox
				showInfoModal={displayInfoModal}
				setShowInfoModal={setDisplayInfoModal}
				message={message}
			/>
		</div>
	)
}

export default SystemReports;

